import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import VendorLayout from "./VendorLayout";
import ProtectedVendorRoute from "./components/ProtectedVendorRoute";

/* Auth */
import VendorLogin    from "./pages/Auth/VendorLogin";
import VendorRegister from "./pages/Auth/VendorRegister";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword  from "./pages/Auth/ResetPassword";

/* Pages */
import Dashboard          from "./pages/Dashboard/Dashboard";
import MainCategoriesPage from "./pages/MainCategories/MainCategoriesPage";
import SubCategoriesPage  from "./pages/SubCategories/SubCategoriesPage";

import ProductList from "./pages/Products/ProductList";
import AddProduct  from "./pages/Products/AddProduct";
import EditProduct from "./pages/Products/EditProduct";

import OrdersList     from "./pages/Orders/OrdersList";
import OrderDetails   from "./pages/Orders/OrderDetails";
import UpdateShipping from "./pages/Orders/UpdateShipping";
import Inventory      from "./pages/Inventory/Inventory";

import Wallet        from "./pages/Payouts/Wallet";
import RequestPayout from "./pages/Payouts/RequestPayout";
import PayoutHistory from "./pages/Payouts/PayoutHistory";

import StoreProfile from "./pages/Profile/StoreProfile";
import BankDetails  from "./pages/Profile/BankDetails";
import ProfileEdit  from "./pages/Profile/EditProfile";

/* ✅ Reviews module */
import CustomerReviews from "./pages/CustomerReviews";

/* ✅ Followers module */
import FollowersPage from "./pages/Followers/FollowersPage";
export default function VendorRoutes() {
  return (
    <Routes>
      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Public auth routes */}
      <Route path="/login"           element={<VendorLogin />} />
      <Route path="/register"        element={<VendorRegister />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password"  element={<ResetPassword />} />

      {/* ✅ Protected layout */}
      <Route
        path="/*"
        element={
          <ProtectedVendorRoute>
            <VendorLayout />
          </ProtectedVendorRoute>
        }
      >
        <Route path="dashboard"       element={<Dashboard />} />
        <Route path="main-categories" element={<MainCategoriesPage />} />
        <Route path="sub-categories"  element={<SubCategoriesPage />} />

        <Route path="products"          element={<ProductList />} />
        <Route path="products/add"      element={<AddProduct />} />
        <Route path="products/edit/:id" element={<EditProduct />} />

        <Route path="orders"              element={<OrdersList />} />
        <Route path="orders/:id"          element={<OrderDetails />} />
        <Route path="orders/:id/shipping" element={<UpdateShipping />} />

        <Route path="inventory" element={<Inventory />} />

        {/* ✅ Followers route */}
        <Route path="followers" element={<FollowersPage />} />

        <Route path="payouts"         element={<Wallet />} />
        <Route path="payouts/wallet"  element={<Wallet />} />
        <Route path="payouts/request" element={<RequestPayout />} />
        <Route path="payouts/history" element={<PayoutHistory />} />

        {/* ✅ Reviews route */}
        <Route path="reviews" element={<CustomerReviews />} />

        <Route path="profile/edit"  element={<ProfileEdit />} />
        <Route path="profile/store" element={<StoreProfile />} />
        <Route path="profile/bank"  element={<BankDetails />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}